import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    create: -1,
    details: -1,
  },
  data: {},
  meta: {},
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.POS_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          create: 0,
        },
      };
    case ACTION_TYPES.POS_CREATE_SUCCEED:
      return {
        ...state,
        status: {
          create: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.POS_CREATE_FAILED:
      return {
        ...state,
        status: {
          create: 2,
        },
        error,
      };
    case ACTION_TYPES.POS_GET_REQUESTED:
      return {
        ...state,
        status: {
          details: 0,
        },
      };
    case ACTION_TYPES.POS_GET_SUCCEED:
      return {
        ...state,
        status: {
          details: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.POS_GET_FAILED:
      return {
        ...state,
        status: {
          details: 2,
        },
        error,
      };
    default:
      return state;
  }
}
